import * as React from 'react';
import {
  VIEW,
  trackView,
  trackInteraction,
  INTERACTION,
  MParticleDataProp,
  IEventData,
} from './tracker';
import { trackPageView } from './elog/mparticle_tracker';
import { PageViewEvent } from './elog/mparticle_types';

export function useViewTracking(
  mParticleViewData: MParticleDataProp,
  shouldTrack: boolean,
) {
  const [hasViewed, setView] = React.useState(false);

  React.useEffect(() => {
    if (!shouldTrack || hasViewed) return;

    trackView({
      eventType: VIEW,
      mParticleView: mParticleViewData,
    });

    setView(true);
  }, [hasViewed, shouldTrack, mParticleViewData]);

  return [hasViewed, setView];
}

export function useInteractionTracking(
  mParticleInteractionData: MParticleDataProp,
) {
  // TODO: make this type more specific to _always_ include eventName
  const [clickInfo, setClickInfo] = React.useState<Partial<IEventData['mParticleInteraction']>>({});
  React.useEffect(() => {
    if (mParticleInteractionData && Object.keys(clickInfo).length) {
      trackInteraction({
        eventType: INTERACTION,
        mParticleInteraction: {
          eventName: '', // TODO: can this be optional?
          ...mParticleInteractionData,
          ...clickInfo,
        },
      });
    }
  }, [mParticleInteractionData, clickInfo]);


  return setClickInfo;
}

export function usePageViewTracking(mParticlePageView: PageViewEvent, triggerEffectProps) {
  React.useEffect(() => {
    if (!mParticlePageView) { return; }

    trackPageView(mParticlePageView);
  }, [mParticlePageView, triggerEffectProps]);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/use_tracking.tsx